import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { AsyncApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { Investment } from '../../models/investment.model';
import { InvestmentFormComponent } from '../../forms/investment-form/investment-form';
import { ConfirmationDialogService } from '../../services/utility/confirmation-dialog.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-investment-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer, InvestmentFormComponent],
  templateUrl: './investment-side-panel.html'
})
export class InvestmentSidePanelComponent extends AbstractToggleSidePanelComponent<Investment>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly tradeApiEnum = EntityApiEnum.FIN_INVESTMENT;
  private readonly confirmationService = inject(ConfirmationDialogService);

  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: Investment): void {
    
  }

  
  public readonly form: FormGroup<any> =this.formFactory.createInvestmentForm();
  public readonly data = model<Investment>();
  public readonly finIsinId = input.required<number>();
  public readonly investmentType = input.required<number>();

  public readonly title= computed(()=>{
    const investmentType = this.investmentType();
    return investmentType ==3 ? 'Dividendo' : (investmentType==1 ? 'Acquisto' : 'Vendita')
  });

  async onSaveClicked() {
    const isinId = this.finIsinId();
    const investmentType = this.investmentType();
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const generalValues = this.form.getRawValue();
      const quantity = investmentType==3 ? 0 : (investmentType==1 ? Math.abs(generalValues.quantity): - Math.abs(generalValues.quantity));
      const contestualCredit= investmentType==1 ? generalValues.contestualCredit : 0;
      const toSave = {
        ...generalValues, 
        finIsinId: isinId, 
        contestualCredit: contestualCredit, 
        quantity: quantity} as Investment;
     

      const investentSaved: Investment = await this.asyncApi.save(this.tradeApiEnum, toSave, toSave.finInvestmentId);

      this.onSave.emit(investentSaved);
      this.data.set(investentSaved);
      // this.formView.set(false)
    }
  }

  public async onDeleteClicked() {
    const data = this.data();
    await new Promise<void>((resolve) => {
      this.confirmationService.show('Sei sicuro di voler eliminare questo trade di investimento?', async () => {
          await this.asyncApi.deleteById(this.tradeApiEnum, data?.finInvestmentId!);
          this.onDelete.emit();
          resolve();
      });
    });
  }

}